import { render } from "./SymbolLink.vue?vue&type=template&id=0772f986&scoped=true&ts=true"
import script from "./SymbolLink.vue?vue&type=script&lang=ts"
export * from "./SymbolLink.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0772f986"]])

export default __exports__